'use client';

import React from 'react';
import { DOWNLOAD_APP_CTA } from '../../constants';
import caregiver from '../../assets/images/caregiver-avatar.png';
import { canUseWindow } from '../../wag-react/common/xenv';
import { TooltipBouncer, TooltipBouncerProps } from '../../wag-react/components/floating-action-buttons/components/TooltipBouncer';
export type DownloadAppBouncerProps = Omit<TooltipBouncerProps, 'avatar' | 'tooltip'> & {
  href?: string;
};
export const DownloadAppBouncer = ({
  href = DOWNLOAD_APP_CTA,
  ...rest
}: DownloadAppBouncerProps) => {
  const goToDownloadApp = () => {
    if (!canUseWindow) {
      return;
    }
    window.open(href, '_blank');
  };
  return <TooltipBouncer as="aside" avatar={{
    src: caregiver,
    alt: 'Wag! Caregiver'
  }} tooltip={{
    text: 'Get the app'
  }} display={['flex', 'none', null]} onClick={goToDownloadApp} {...rest} data-sentry-element="TooltipBouncer" data-sentry-component="DownloadAppBouncer" data-sentry-source-file="index.tsx" />;
};